// src/components/Shared/Answer.js

import React from 'react';
import styles from '../Exam/Exam.module.css';

const Answer = ({ answer, index, isSelected, handleAnswerSelection, isSingleChoice }) => (
    <li className={styles.answer}>
        <label>
            <input
                type={isSingleChoice ? "radio" : "checkbox"}
                name={isSingleChoice ? "single-choice" : `multi-choice-${index}`}
                checked={isSelected}
                onChange={() => handleAnswerSelection(index)}
                tabIndex={0}
            />
            {answer}
        </label>
    </li>
);

export default Answer;
